import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from "@angular/material/dialog";
import { Injectable } from "@angular/core";
import {
  ConfirmDialogComponent,
  ConfirmDialogData,
} from "@app/components/confirm-dialog/confirm-dialog.component";

export class WcgDialog {
  private _dialogRef: MatDialogRef<ConfirmDialogComponent> | undefined;
  public get dialogRef() {
    return this._dialogRef;
  }

  public set additionalMessage(value: string) {
    if (this._dialogRef?.componentInstance?.data) {
      this._dialogRef.componentInstance.data.additionalMessage = value;
    }
  }
  /**
   *
   */
  constructor(
    dialogReference: MatDialogRef<ConfirmDialogComponent> | undefined
  ) {
    this._dialogRef = dialogReference;
  }
}

@Injectable({
  providedIn: "root",
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  openConfirmDialog(config: {
    rows?: number;
    enableTextField?: boolean;
    mandatoryTextField?: boolean;
    minlengthTextField?: number;
    title?: string;
    message: string;
    additionalMessage: string;
    confirmText?: string;
    cancelText?: string;
    onConfirm?: (textFieldValue?: string) => void;
    onCancel?: () => void;
    confirmTextStyle?: string;
    textFieldLabel?: string;
    textFieldPlaceholder?: string;
    textFieldMaxLength?: number;
    showCancel?: boolean;
  }): WcgDialog {
    const dialogConfig = new MatDialogConfig<ConfirmDialogData>();
    dialogConfig.width = "400px";
    dialogConfig.disableClose = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.backdropClass = "dialog-backdrop-fade";
    dialogConfig.panelClass = "dialog-slide-up";
    dialogConfig.enterAnimationDuration = "300ms";
    dialogConfig.exitAnimationDuration = "200ms";
    dialogConfig.data = {
      enableTextField: config.enableTextField || false,
      mandatoryTextField: config.mandatoryTextField || false,
      minlengthTextField: config.minlengthTextField || 0,
      rows: config.rows || 3,
      title: config.title || "Confirm",
      message: config.message,
      additionalMessage: config.additionalMessage,
      confirmText: config.confirmText || "Yes",
      showCancel: config.showCancel !== false,
      cancelText: config.cancelText || "",
      confirmButtonClass: config.confirmTextStyle || "",
      textFieldLabel: config.textFieldLabel || "",
      textFieldPlaceholder: config.textFieldPlaceholder || "",
      textFieldMaxLength: config.textFieldMaxLength || 2000,
    };

    let dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        config.onConfirm?.(dialogConfig.data?.textFieldValue);
      } else {
        config.onCancel?.();
      }
    });

    return new WcgDialog((dialogRef = dialogRef));
  }
}
